import { styled } from '@mui/system';

import { StyledImageStackProps } from './types';

export const StyledImageStack = styled('div')<StyledImageStackProps>(({ url, height, width }) => ({
  backgroundImage: `url(${String(url)})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  borderRadius: '4px',
  height,
  width,
}));

export const LabelStack = styled('div')<{ labelDataColor?: string; name?: string }>(
  ({ labelDataColor, name }) => ({
    padding: '4px 8px',
    borderRadius: 6,
    height: name ? '' : '30px',
    width: name ? 'auto' : '50px',
    backgroundColor: labelDataColor,
    justifyContent: 'center',
    alignItems: 'center',
  })
);

export const StyledDueDate = styled('div')<{ checked?: boolean; status: string }>(
  ({ theme, checked, status }) => ({
    backgroundColor: checked
      ? theme.palette.success.dark
      : status === 'dueSoon'
      ? theme.palette.warning.light
      : status === 'overDue'
      ? theme.palette.error.main
      : '',
    color: checked
      ? theme.palette.common.white
      : status === 'overDue'
      ? theme.palette.common.white
      : status === 'dueSoon'
      ? theme.palette.common.black
      : theme.palette.error.dark,
    fontSize: '12px',
    fontWeight: '700',
    boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
    paddingLeft: '8px',
    paddingRight: '8px',
    borderRadius: '4px',
  })
);

export const StyledMainStack = styled('div')<{
  image?: any;
  colors?: string;
  selectedManuallyImage?: string;
}>(({ image, colors, selectedManuallyImage }) => ({
  height: '100vh',
  width: '100%',
  overflowY: 'hidden',
  overflowX: 'hidden',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  backgroundImage: selectedManuallyImage ? `url(${selectedManuallyImage})` : `url(${image})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  top: 0,
  left: 0,
}));

export const Heading = styled('div')(() => ({
  width: '100%',
  height: '10%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
